import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const clientsSearchSchema = z.object({
  clientId: z.string().optional(),
});

export const Route = createFileRoute("/dashboard/clients")({
  validateSearch: clientsSearchSchema,
});
